<template>
  <div>
    <div slot="title">
      <h2>Reporte de Evaluaciones para Estímulos</h2>
      <!--<img src='/src/assets/logo-pj-transparente-negro.png' style='object-fit: cover; width: 30vw; height: 30vw; position: relative; right: 5px;'>-->
    </div>    
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top: 20px">
          <div class="col-6">
            <label>Año del Periodo de Evaluación : </label>
          </div>
          <div class="col-5 padding-0">
            <!-- <label>Nombre del Evaluado : </label> -->
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <input
              type="number"
              name="anioPeriodo"
              class="form-control"
              v-model="AnioPeriodo"
            />
          <!-- <div class="col-3">
            <input
              type="date"
              name="fechaInicial"
              class="form-control"
              v-model="fechaInicial"
            />-->
          </div> 
          <div class="col-3">
            <!-- <input
              type="date"
              name="fechaFinal"
              class="form-control"
              v-model="fechaFinal"
            /> -->
          </div>
          <div class="col-4">
            <select class="form-control" v-model="areaEvaluacionEstimulosId" id="areaEvaluacion" v-on:keyup.enter="buscarEvaluacionesEstimulos">
              <option value="-1">Seleccionar un área</option>
              <option value="63">Adolescentes</option>
              <option value="1">Archivo Judicial</option>
              <option value="2">Contraloría Interna</option>
              <option value="3">Compras y Almacen</option>
              <option value="4">Activo Fijo</option>
              <option value="5">Servicios Generales Civil (Mantenimiento)</option>
              <option value="6">Servicios Generales Civil (Intendencia)</option>
              <option value="7">Servicios Generales Penal (Mantenimiento)</option>
              <option value="8">Servicios Generales Penal (Intendencia)</option>
              <option value="9">Administracion de Personal</option>
              <option value="10">Contabilidad y Control Presupuestal</option>
              <option value="11">Dirección de Ejecutores</option>
              <option value="12">Dirección de Informática Civil</option>
              <option value="13">Dirección de Informática Penal</option>
              <option value="14">Dirección de Notificadores Civil</option>
              <option value="15">Dirección de Notificadores Penal</option>
              <option value="16">Instituto de Capacitación</option>
              <option value="17">Justicia Alternativa</option>
              <option value="61">Justicia Alternativa (Vigilancia e intendencia)</option>
              <option value="18">Juzgado Cuarto Familiar</option>
              <option value="19">Juzgado Cuarto Mercantil</option>
              <option value="62">Juzgado de Ejecución de Penas y Medidas de Seguridad(Jurídico 1)</option>
              <option value="20">Juzgado de Oralidad Aguascalientes</option>
              <option value="21">Juzgado de Oralidad Calvillo</option>
              <option value="22">Juzgado de Oralidad Jesús María</option>
              <option value="23">Juzgado de Oralidad Pabellón de Arteaga</option>
              <option value="24">Juzgado de Oralidad Rincón de Romos</option>
              <option value="25">Juzgado Mixto Calvillo</option>
              <option value="26">Juzgado Mixto Jesús María</option>
              <option value="27">Juzgado Mixto Pabellón de Arteaga</option>
              <option value="28">Juzgado Mixto Rincón de Romos</option>
              <option value="29">Juzgado Primero Civil</option>
              <option value="30">Juzgado Primero Familiar</option>
              <option value="31">Juzgado Primero Mercantil</option>
              <option value="32">Juzgado Quinto Familiar</option>
              <option value="33">Juzgado Quinto Mercantil</option>
              <option value="34">Juzgado Segundo Civil</option>
              <option value="35">Juzgado Segundo Familiar</option>
              <option value="36">Juzgado Segundo Mercantil</option>
              <option value="37">Juzgado Segundo Penal</option>
              <option value="38">Juzgado Sexto Familiar</option>
              <option value="39">Juzgado Sexto Mercantil</option>
              <option value="40">Juzgado Sexto Penal</option>
              <option value="41">Juzgado Tercero Civil</option>
              <option value="42">Juzgado Tercero Familiar</option>
              <option value="43">Juzgado Tercero Mercantil</option>
              <option value="44">Oficialía Mayor</option>
              <option value="45">Presidencia</option>
              <option value="46">Psicología</option>
              <option value="47">Dirección Jurídica</option>
              <option value="48">Oficina de Comunicación</option>
              <option value="49">Secretaría Particular</option>
              <option value="50">Secretaría Técnica</option>
              <option value="51">Unidad de Igualdad de Género</option>
              <option value="52">Sala Administrativa</option>
              <option value="53">Sala Civil</option>
              <option value="54">Sala Penal</option>
              <option value="55">Secretaría General de Acuerdos</option>
              <option value="56">Sala de Lecturas</option>
              <option value="57">Oficialía de Partes</option>
              <option value="58">Juzgado Primero Laboral</option>
              <option value="59">Juzgado Segundo Laboral</option>
              <option value="60">Dirección de Ejecutores Vespertino</option>
            </select>
          </div>
          <!-- <div class="col-2 padding-0">
            <input
              type="text"
              placeholder="Buscar.."
              name="search"
              class="form-control"
              v-model="nombreEvaluadoBusqueda"
              v-on:keyup.enter="buscarEvaluacionesEstimulos"
            />
          </div> -->
          <div class="col-2 padding-0">
            <button
              type="submit"
              class="form-control"
              @click="buscarEvaluacionesEstimulos"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
        <!-- <div class="row" style="margin-top: 30px">
          <div class="col-3">
            <select class="form-control" v-model="TipoPlazaEvaluadoIdAux">
              <option value="0">Todos (Tipo de Plaza)</option>
              <option value="1">De Confianza</option>
              <option value="2">De Base</option>
              <option value="3">Becarios</option>
            </select>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="TipoContratoEvaluadoIdAux">
              <option value="0">Todos (Tipo de Contrato)</option>
              <option value="1">En Interinato</option>
              <option value="2">De Base</option>
            </select>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="EntregaPresidenciaAux">
              <option value="0">Todas (Estatus de Entrega)</option>
              <option value="1">Entregadas</option>
              <option value="2">Pendientes</option>
            </select>
          </div>
          <div class="col-3">
            <input type="checkbox" v-model="MostrarGraficasAux" />
            <span>Mostrar Gráficas</span>
          </div>
        </div> -->
        <div class="row" style="margin-top: 30px">
          <div class="col-8"></div>
          <div class="col-3 padding-0">
            <input
              type="button"
              v-if="evaluaciones.length > 0"
              class="form-control"
              @click="generarReporte"
              value="Imprimir Resultado"
            />
          </div>
        </div>
        <!-- <div class="row" style="margin-top: 30px">
          <div class="col-8"></div>
          <div class="col-3 padding-0">
            <input
              type="button"
              v-if="ImpresionConcluida"
              class="form-control"
              @click="MarcarEvaluacionesEntregadas"
              value="Marcar Evaluaciones como Entregadas"
            />
          </div>
        </div> -->
        <div class="row">
          <div class="col-12">
            <h6 v-if="evaluaciones.length > 0">
              Resultados ({{ evaluaciones.length }})
            </h6>
            <h6 v-if="evaluaciones.length > 0">
              Periodo de Evaluación: {{this.formatoDeFecha(this.fechaInicial)}} al {{this.formatoDeFecha(this.fechaFinal)}}
            </h6>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table
              class="table table-striped table-light table-hover"
              id="tablaEvaluaciones"
            >
              <thead class="thead-dark">
                <tr>
                  <th class="col-9">Nombre</th>
                  <th class="col-1">Bono</th>
                  <th class="col-3">Resultado</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr
                  v-for="(evaluacion, indice) in evaluaciones"
                  v-bind:key="indice"
                >
                  <td>{{ evaluacion.nombreEvaluado }} </td>
                  <td><i class="fas fa-award" v-if="indice < 3 && parseFloat(evaluacion.Resultado) >= 8"></i></td>
                  <td>{{ parseFloat(evaluacion.Resultado).toFixed(1) }}</td>
                </tr>
                <tr v-if="evaluaciones.length == 0">
                  <td colspan="8">
                    No se encontraron evaluaciones contestadas en el periodo
                    marcado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";
import highcharts from "@/../static/js/highchart";

export default {
  data() {
    return {
      areaEvaluacionEstimulosId: -1,
      areaEvaluacion: "",
      enumeraciones,
      nombreEvaluadoBusqueda: "", //Contiene en valor del nombre del evaluado para busqueda
      evaluaciones: [],
      NombreCategorias: [
        "Intrapersonal",
        "InterPersonal",
        "Desarrollo de Tareas",
        "Entorno",
        "Gerencia",
      ],
      NombreCompetencias: [
        "Autocontrol",
        "Confianza y seguridad",
        "Resistencia a la adversidad",
        "Comunicación",
        "Establecimiento de relaciones",
        "Negociación",
        "Trabajo en equipo",
        "Iniciativa",
        "Orientación a resultados",
        "Capacidad de análisis",
        "Toma de decisiones",
        "Conocimiento de la institución",
        "Orientación al usuario",
        "Apertura",
        "Identificación con la institución",
        "Dirección",
        "Liderazgo",
        "Planificación y organización",
        "Visión y Anticipación",
      ],
      fechaInicial: null,
      fechaFinal: null,
      TipoPlazaEvaluadoIdAux: 0,
      TipoContratoEvaluadoIdAux: 0,
      NumeroFilasPagina: 20,
      MostrarGraficas: false,
      MostrarGraficasAux: false,
      EntregaPresidenciaAux: 0,
      ImpresionConcluida: false,
      datosLocales: [
        {
          Id: 0,
          key: "Area_TabLaborales",
          valor: {
            Id: 0,
            nombre: null,
          },
        },
      ],
      AnioPeriodo: 0
    };
  },
  components: {
    highcharts,
    C001Area: catalogos.PJ.C001Area,
  },
  methods: {
    buscarEvaluaciones: function () {
      //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
      //Carga la información necesaria para hacer la petición
      var peticion = {
        esPrueba: false,
        nombreEvaluadoBusqueda: this.nombreEvaluadoBusqueda,
        estatusSolicitud: null,
        fechaInicial: this.fechaInicial,
        fechaFinal: this.fechaFinal,
        ConResultado: true,
        EstatusEvaluacion: 3,
        TipoPlazaEvaluadoId: this.TipoPlazaEvaluadoId,
        TipoContratoEvaluadoId: this.TipoContratoEvaluadoId,
        EntregaPresidencia: this.EntregaPresidencia,
      };
      this.ImpresionConcluida = false;
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(api.conexion + api.SISEVA.funcion.GetEvaluaciones, peticion)
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            //console.log(response)
            $("#alertaNumeroNomina").hide(); //Oculta la alerta de número de nómina no válido (filtro de busqueda)
            this.evaluaciones = response.data.evaluaciones; //Carga los datos necesarios
            var evals = this.evaluaciones;

            this.evaluaciones = evals;
            this.NumeroFilasPagina = 20;
            if (this.MostrarGraficasAux) {
              this.NumeroFilasPagina += 30;
              this.MostrarGraficas = true;
            }

            this.$nextTick(() => {
              PaginarTabla("tablaEvaluaciones", this.NumeroFilasPagina);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    buscarEvaluacionesEstimulos: function () {
      //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
      //Carga la información necesaria para hacer la petición
      this.fechaInicial = new Date(this.AnioPeriodo, 0,1).toISOString().split("T")[0];
      this.fechaFinal =  new Date(this.AnioPeriodo, 10, 30).toISOString().split("T")[0];
      if(this.validacionDatos())
      {
        const sel = document.getElementById("areaEvaluacion");
        const text= sel.options[sel.selectedIndex].text;
        this.areaEvaluacion = text;
        var AreaId =
          this.datosLocales[0].valor.Id != 0
            ? this.datosLocales[0].valor.Id
            : null;
        var peticion = {
          esPrueba: false,
          fechaInicial: this.fechaInicial,
          fechaFinal: this.fechaFinal,
          areaEvaluacionEstimulosId: parseInt(this.areaEvaluacionEstimulosId)
        };
        this.ImpresionConcluida = false;
        comun.SeEstaCargandoInformacion(true);
        axios
          .post(
            api.conexion + api.SISEVA.funcion.GetEvaluacionesEstimulos,
            peticion
          )
          .then((response) => {
            if (response.data.SiHayError == false) {
              //En caso de que la petición sea exitosa
              //console.log(response)
              $("#alertaNumeroNomina").hide(); //Oculta la alerta de número de nómina no válido (filtro de busqueda)
              this.evaluaciones = response.data.evaluaciones; //Carga los datos necesarios
              var evals = this.evaluaciones;

              this.evaluaciones = evals;
              this.NumeroFilasPagina = 40;
              if (this.MostrarGraficasAux) {
                this.NumeroFilasPagina += 30;
                this.MostrarGraficas = true;
              }

              this.$nextTick(() => {
                PaginarTabla("tablaEvaluaciones", this.NumeroFilasPagina);
              });
            } else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
      }
    },
    anadirEvaluadores: function (idEvaluacion) {
      //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
      this.$router.push({
        name: "DetallesEvaluado",
        params: { idEvaluacion: idEvaluacion },
      });
    },
    generarReporte: function () {
      var popupWin = window.open("", "_blank", "width=563,height=750");
      popupWin.document.open();
      popupWin.document.write(
        "<html><head><title>Reporte de Evaluaciones</title>"
      );
      popupWin.document.write(
        "<style>  tr.page-break  { display: block; page-break-after: always; }</style>"
      );
      popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
      popupWin.document.write(
        '<link href="/static/css/bootstrap.min.css" rel="stylesheet">'
      );
      popupWin.document.write(
        '<link href="/static/css/all.min.css" rel="stylesheet">'
      );
      popupWin.document.write(
        '<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">'
      );
      popupWin.document.write("</head><body >");
      popupWin.document.write(
        "<img src='/static/img/logo-pj-transparente-negro.d628a6d.png' style='object-fit: cover; width: 30vw; height: 30vw; position: relative; left: 0vw;' >"
      );
      popupWin.document.write(
        '<h1 style="position: relative; left: 30vw;">REPORTE DE EVALUACIONES</h1><br>'
      );
      popupWin.document.write(
        "<h2>Contraloría Interna - Sistema de Evaluación del Desempeño - SISEVA</h2><br>"
      );
      //popupWin.document.write('<h3>'+this.datosLocales[0].valor.Nombre+'</h3>');
      popupWin.document.write("<h2>"+this.areaEvaluacion+"</h2>");
      /*popupWin.document.write(
        "<h3>Servcios Generales Penal - Mantenimiento</h3>"
      );*/

      popupWin.document.write(
        '<table class="table table-striped table-light table-hover" id="tablaEvaluaciones" style="font-size: 32px;">'
      );
      var resultados = document.getElementById("tablaEvaluaciones").innerHTML;
      //console.log(resultados.indexOf('style="display: none; opacity: 0;"'));
      resultados = resultados
        .split('style="display: none; opacity: 0;"')
        .join('style="opacity: 1; display: table-row;"');
      resultados = resultados
        .split('style="opacity: 0; display: none;"')
        .join('style="opacity: 1; display: table-row;"');
      //console.log(resultados.indexOf('class="visible-element"'));
      resultados = resultados
        .split('class="visible-element"')
        .join('style="opacity: 0"');
      //resultados = resultados.split('class="hidden-element"').join('style="opacity: 1"');
      //resultados = resultados.split('</td></tr>').join('</td></tr><tr><th>Nombre</th><th>Resultado</th><th>Intrapersonal</th><th>InterPersonal</th><th>Desarrollo de Tareas</th><th>Entorno</th><th>Gerencia</th><th>Áreas de Oportunidad</th><th class="visible-element">Acciones</th></tr>');
      //resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
      //console.log(resultados);
      popupWin.document.write(resultados);
      popupWin.document.write("</table>");
      popupWin.document.write("</body></html>");
    //   var css = "@page { size: landscape; }",
    //     head =
    //       popupWin.document.head || document.getElementsByTagName("head")[0],
    //     style = popupWin.document.createElement("style");

    //   style.type = "text/css";
    //   style.media = "print";

    //   if (style.styleSheet) {
    //     style.styleSheet.cssText = css;
    //   } else {
    //     style.appendChild(popupWin.document.createTextNode(css));
    //   }

    //   head.appendChild(style);
      setTimeout(function () {
        popupWin.print();
      }, 1000);
      popupWin.document.close();
      popupWin.focus();
      this.ImpresionConcluida = true;
    },
    promedio: function (resultados) {
      var x;
      var suma = 0;
      var contador = 0;
      for (x of resultados) {
        if (x != null) {
          suma += parseFloat(x);
          contador++;
        }
      }
      return Math.round((suma / contador + Number.EPSILON) * 100) / 100;
    },
    CalcularAreasDeOportunidad: function (resultados, perfil) {
      var x;
      var salida = "<ul>";
      for (x in resultados) {
        if (
          resultados[x] != null &&
          parseFloat(resultados[x]) + 1 <= parseFloat(perfil[x])
        ) {
          salida += "<li>" + this.NombreCompetencias[x] + "</li>";
        }
      }
      salida += "</ul>";
      return salida;
    },
    verDetalles: function (idEvaluacion, idSolicitud) {
      //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
      this.$router.push({
        name: "DetallesEvaluacion",
        params: { idEvaluacion: idEvaluacion, infoPersona: null },
      });
    },
    EvaluadoresConComentario: function (evaluador) {
      return evaluador.filter(function (u) {
        return evaluador.Observaciones != null && evaluador.Observaciones != "";
      });
    },
    ObtenerPromedio: function (PerfilCategorias) {
      var l = PerfilCategorias.length;
      var i = 0;
      var total = 0;
      for (i = 0; i < l; i++) {
        total += PerfilCategorias[i];
      }
      return Math.round((total / l + Number.EPSILON) * 100) / 100;
    },
    MarcarEvaluacionesEntregadas: function () {
      var IdEvaluaciones = [];
      var ev;
      for (ev of this.evaluaciones) {
        IdEvaluaciones.push(ev.EvaluacionId);
      }
      //console.log(IdEvaluaciones);
      var peticion = {
        esPrueba: false,
        IdEvaluaciones: IdEvaluaciones,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SISEVA.funcion.MarcarEvaluacionesEntregadas,
          peticion
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            var boton = this.boton;
            comun.mensajeDeAlerta(
              "Las evaluaciones han sido correctamente marcadas como entregadas a presidencia en la base de datos.",
              null,
              null
            );
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    cambioAreaHistorialLaboral(datos) {
      //console.log(datos)
      this.datosLocales[0].valor.Id = parseInt(datos.target.value);
      this.datosLocales[0].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    validacionDatos(){
      if(this.AnioPeriodo==0)
      {
        comun.mensajeDeAlerta("El año para periodo no puede ser nulo.", null, null);
        return false;
      }
      if(this.AnioPeriodo > parseInt(moment().format('YYYY')))
      {
        comun.mensajeDeAlerta("El año para periodo no puede ser superior al vigente.", null, null);
        return false;
      };
      if(this.AnioPeriodo<2020)
      {
        comun.mensajeDeAlerta("El año para periodo no puede ser inferior al 2020.", null, null);
        return false;
      };
      if(this.areaEvaluacionEstimulosId<0)
      {
        comun.mensajeDeAlerta("Seleccione el área para consulta.", null, null);
        return false;
      };
      return true;
    },
    formatoDeFecha(fecha)
    {
      return moment(fecha).locale('es-Es').format('DD-MMMM-YYYY').toUpperCase();
    }
  },
  mounted: function mounted() {
    //Al cargarse la vista hace la busqueda de evaluaciones sin filtros
    var date = new Date();
    // this.fechaInicial = new Date(date.getFullYear(), 1, 1)
    //   .toISOString()
    //   .split("T")[0];
    // this.fechaFinal = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    //   .toISOString()
    //   .split("T")[0];
    //this.buscarEvaluaciones()
    this.AnioPeriodo = moment().format('YYYY');
    
  },
  computed: {
    TipoPlazaEvaluadoId: function () {
      return this.TipoPlazaEvaluadoIdAux != 0
        ? parseInt(this.TipoPlazaEvaluadoIdAux)
        : null;
    },
    TipoContratoEvaluadoId: function () {
      return this.TipoContratoEvaluadoIdAux != 0
        ? parseInt(this.TipoContratoEvaluadoIdAux)
        : null;
    },
    EntregaPresidencia: function () {
      if (this.EntregaPresidenciaAux == 0) {
        return null;
      } else if (this.EntregaPresidenciaAux == 1) {
        return true;
      } else {
        return false;
      }
    },
    // contains only Alex and James
  },
};
</script>

<style scoped>
.padding-0 {
  padding-right: 1px;
  padding-left: 1px;
}

.hidden-element {
  opacity: 0;
}

.visible-element {
  opacity: 1;
}

@media print {
  .page-break {
    display: block;
    page-break-after: always;
  }

  .page-nobreak {
    display: block;
    page-break-after: avoid;
  }
}

.lista-competencias p {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/ReporteEvaluacionesEstimulos.vue